import React from "react";
import { useQuery } from "react-query";
import { getPublicCertificateDownloadFormParams } from "./gateway";

function useGetPublicCertificateDownloadFormParams() {
  return useQuery({
    queryFn: getPublicCertificateDownloadFormParams,
    queryKey: ["publicCertificateDownloadFormParams"],
    refetchOnWindowFocus: false,
  });
}

export default useGetPublicCertificateDownloadFormParams;
